const BASE_URL_LOCAL = 'http://localhost:8000';
const BASE_URL_DEV = 'https://dev.api.others.co';
const BASE_URL_STAGE = 'https://stage.api.others.co';
const BASE_URL_PROD = 'https://api.others.co';

// DEV: change the endpoint here
export const BASE_URL_PREFIX = `${BASE_URL_PROD}`

export const BASE_URL = `${BASE_URL_PREFIX}/api/`
